"use strict";
const { isQuoted, unQuotedString } = require('../../quotedSearchString');
const createSearchStringQuery = searchString => {
    if (!searchString) {
        return { or: [] };
    }
    const unQuotedSearchString = unQuotedString(searchString);
    if (isQuoted(searchString)) {
        return {
            or: [
                { yourOrderNumber: unQuotedSearchString },
                { orderNumber: unQuotedSearchString },
                { supplierOrderNumber: unQuotedSearchString },
                { ARCNumber: unQuotedSearchString },
                { qvantiOrderNumber: unQuotedSearchString },
            ],
        };
    }
    return {
        or: [
            {
                '$customerSubUnit.name$': {
                    iLike: `%${unQuotedSearchString.replace(' ', '%')}%`,
                },
            },
            {
                '$customerSubUnit.customerNumber$': unQuotedSearchString,
            },
            {
                '$supplierCustomer.customerNumber$': unQuotedSearchString,
            },
            {
                '$supplierCustomer.name$': {
                    iLike: `%${unQuotedSearchString.replace(' ', '%')}%`,
                },
            },
            {
                yourOrderNumber: {
                    iLike: `%${unQuotedSearchString.replace(' ', '%')}%`,
                },
            },
            {
                orderNumber: {
                    iLike: `%${unQuotedSearchString.replace(' ', '%')}%` || undefined,
                },
            },
            {
                supplierOrderNumber: {
                    iLike: `%${unQuotedSearchString.replace(' ', '%')}%` || undefined,
                },
            },
            {
                qvantiOrderNumber: {
                    iLike: `%${unQuotedSearchString.replace(' ', '%')}%` || undefined,
                },
            },
        ],
    };
};
module.exports = createSearchStringQuery;
